import { Cpu, Book, Presentation, FileCog, MonitorCog, ListCheck } from "lucide-react";
import dbJson from "../data/db.json";
import { iconMap } from "../types/icons";
import { useEffect, useState } from "react";
import { SupportFiles, SupportFileType } from "../types/supportFiles";
import { ScrollToTopButton } from "./ui/scrollToTopButton";

// const supportFiles = [
//     { id: 1, type: "presentation", title: 'Презентация: "Пультовая система централизованного мониторинга удаленных стационарных объектов в интересах охраны и пожарной безопасности "Щит""', format: "ppt", href: "https://www.stadis.pro/images/stories/docum1/system_shield_tochka_e.ppt", icon: Presentation },
//     { id: 2, type: "presentation", title: 'Презентация: "Комплексная автоматизированная система подогрева тепловозов «Бриз»"', format: "ppt", href: "https://www.stadis.pro/images/stories/docum1/complex_automated_heating_system_briz.pps", icon: Presentation },
//     { id: 3, type: "presentation", title: 'Презентация: "Аппаратно-программный комплекс беспроводной передачи биомедицинских данных о состоянии человека «Орбита»"', format: "ppt", href: "https://www.stadis.pro/images/stories/docum1/mpak_orbita.ppt", icon: Presentation },
//     { id: 4, type: "instruction", title: 'Инструкция по эксплуатации "Точка 4М"', format: "pdf", href: "https://www.stadis.pro/images/stories/docum1/toshka-4m-rukov.pdf", icon: ListCheck },
//     { id: 5, type: "instruction", title: 'Инструкция по эксплуатации "Точка-8М"', format: "pdf", href: "https://www.stadis.pro/images/stories/docum1/tosnka-8m-instr.pdf", icon: ListCheck },
//     { id: 6, type: "passport", title: 'Паспорт "Орбита"', format: "pdf", href: "https://www.stadis.pro/images/stories/docum1/pasport_orbita.pdf", icon: Book },
//     { id: 7, type: "manual", title: 'Руководство по быстрому старту "Орбита"', format: "pdf", href: "https://www.stadis.pro/images/stories/docum1/orbita_bystryi_start.pdf", icon: Cpu },
//     { id: 8, type: "instruction", title: 'Инструкция по эксплуатации "Орбита"', format: "pdf", href: "https://www.stadis.pro/images/stories/docum1/orbita-instr.pdf", icon: ListCheck },
//     { id: 9, type: "manual", title: 'Руководство по быстрому старту "Орбита-К"', format: "pdf", href: "https://www.stadis.pro/images/stories/docum1/orbita_k_bystryi_start.pdf", icon: Cpu },
//     { id: 10, type: "passport", title: 'Паспорт "Орбита-К"', format: "pdf", href: "https://www.stadis.pro/images/stories/docum1/pasport_orbita_k.pdf", icon: Book },
//     { id: 11, type: "instruction", title: 'Инструкция по эксплуатации "Точка-Т"', format: "pdf", href: "https://www.stadis.pro/images/stories/docum1/instr_tochka_t.pdf", icon: ListCheck },
//     { id: 12, type: "passport", title: 'Паспорт "Точка-Т"', format: "pdf", href: "https://www.stadis.pro/images/stories/docum1/pasport_tochka_t.pdf", icon: Book },
//     { id: 13, type: "instruction", title: 'Инструкция по эксплуатации "Точка Е"', format: "pdf", href: "https://www.stadis.pro/images/stories/docum1/tochka_e.pdf", icon: ListCheck },
//     { id: 14, type: "passport", title: 'Паспорт ИСС', format: "pdf", href: "https://www.stadis.pro/images/stories/docum1/iss_pasport.pdf", icon: Book },
//     { id: 15, type: "instruction", title: 'Инструкция по эксплуатации ИСС', format: "pdf", href: "https://www.stadis.pro/images/stories/docum1/iss_re.pdf", icon: ListCheck },
//     { id: 16, type: "manual", title: 'Руководство по эксплуатации USB-хаба', format: "pdf", href: "https://www.stadis.pro/images/stories/docum1/USBHUB.pdf?v1", icon: Cpu },
//     { id: 17, type: "manual", title: 'Система дистанционного контроля и управления производственными технологическими процессами', format: "pdf", href: "https://www.stadis.pro/images/stories/docum1/tochka_a_re.pdf", icon: Cpu },
//     { id: 18, type: "manual", title: 'Технические средства индивидуальной охраны и пожарной безопасности с оповещением на сотовый телефон', format: "pdf", href: "https://www.stadis.pro/images/stories/docum1/informaciya_o_dome_v_tvoem_telefone.pdf", icon: Cpu },
//     { id: 19, type: "passport", title: 'Паспорт Точка-4М', format: "pdf", href: "https://www.stadis.pro/images/stories/docum1/pasport_tochka_4M.pdf", icon: Book },
//     { id: 20, type: "passport", title: 'Паспорт Точка-4МБ', format: "pdf", href: "https://www.stadis.pro/images/stories/docum1/pasport_tochka_4MB.pdf", icon: Book },
//     { id: 21, type: "passport", title: 'Паспорт Точка-8М', format: "pdf", href: "https://www.stadis.pro/images/stories/docum1/pasport_tochka_8M.pdf", icon: Book },
//     { id: 22, type: "passport", title: 'Паспорт Точка-8МБ1', format: "pdf", href: "https://www.stadis.pro/images/stories/docum1/pasport_tochka_8MB1.pdf", icon: Book },
//     { id: 23, type: "passport", title: 'Паспорт Точка-8МБ3', format: "pdf", href: "https://www.stadis.pro/images/stories/docum1/pasport_tochka_8MB3.pdf", icon: Book },
//     { id: 24, type: "passport", title: 'Паспорт ИБП-1 v2.01', format: "pdf", href: "https://www.stadis.pro/images/stories/docum1/-1_v2.01.pdf", icon: Book },
//     { id: 25, type: "passport", title: 'Паспорт ИБП-3А v2.01', format: "pdf", href: "https://www.stadis.pro/images/stories/docum1/-3_v2.01.pdf", icon: Book },
//     { id: 26, type: "passport", title: 'Паспорт АС DС 40W', format: "pdf", href: "https://www.stadis.pro/images/stories/docum1/led_40w_v1.02.pdf", icon: Book },
//     { id: 27, type: "passport", title: 'Паспорт АС DС 8W', format: "pdf", href: "https://www.stadis.pro/images/stories/docum1/led_8w_v1.01.pdf", icon: Book },
//     { id: 28, type: "passport", title: 'Паспорт LED-3-50V', format: "pdf", href: "https://www.stadis.pro/images/stories/docum1/led_3_50V.pdf", icon: Book },
//     { id: 29, type: "passport", title: 'Паспорт LED-7-50V', format: "pdf", href: "https://www.stadis.pro/images/stories/docum1/led_7_50V.pdf", icon: Book },
//     { id: 30, type: "passport", title: 'Паспорт LED-3-110V', format: "pdf", href: "https://www.stadis.pro/images/stories/docum1/led_3_110V.pdf", icon: Book },
//     { id: 31, type: "passport", title: 'Паспорт LED-7-110V', format: "pdf", href: "https://www.stadis.pro/images/stories/docum1/led_7_110V.pdf", icon: Book },
//     { id: 32, type: "utility", title: 'Драйвера для программатора (FTDI)', format: "exe", href: "https://www.stadis.pro/downloads/CDM21228_Setup.exe", icon: FileCog },
//     { id: 33, type: "software", title: 'ПО для настройки ОП "Точка-4м", "Точка-8м", "Точка-8мб", "Орбита", "Орбита-К"', format: "exe", href: "https://www.stadis.pro/downloads/configurator2_install.exe", icon: MonitorCog },
//     { id: 34, type: "software", title: 'ПО для настройки УПДС GSM "Точка-Т" - Конфигуратор УПДС GSM "Точка-Т"', format: "exe", href: "https://www.stadis.pro/downloads/configurator_orbita_t.exe", icon: MonitorCog },
//     { id: 35, type: "utility", title: 'Утилита обновления прошивки приборов серии "Точка" и "Орбита"', format: "exe", href: "https://www.stadis.pro/downloads/firmwarer_install.exe", icon: FileCog },
//     { id: 36, type: "utility", title: 'Утилита управления для USB-хаба', format: "zip", href: "https://www.stadis.pro/downloads/usb_hub_v_1_2.zip", icon: FileCog },
//     { id: 37, type: "software", title: 'ПО "Орбита-клиент" для корпоративных клиентов', format: "exe", href: "https://www.stadis.pro/downloads/OrbitaClientAuto_installer.exe", icon: MonitorCog },
//     { id: 38, type: "software", title: 'ПО "Орбита-клиент" для индивидуального применения', format: "exe", href: "https://www.stadis.pro/downloads/Orbita_2011_Personal_Installer.exe", icon: MonitorCog },
//     { id: 39, type: "software", title: 'ПО "Орбита-Expert"', format: "exe", href: "https://www.stadis.pro/downloads/OrbitaExpert_Installer.exe", icon: MonitorCog },
// ];

const typeLabels: Record<string, string> = {
    all: "Все",
    presentation: "Презентации",
    instruction: "Инструкции",
    passport: "Паспорта",
    manual: "Руководства",
    software: "ПО",
    utility: "Утилиты",
};

export const Support = () => {
    const [files, setFiles] = useState<SupportFiles[]>([])
    const [selectedType, setSelectedType] = useState<SupportFileType | 'all'>('all');

    useEffect(() => {
        setFiles(dbJson.supportFiles as SupportFiles[])
    }, [])

    const availableTypes = Array.from(
        new Set(files.map(f => f.type))
    )

    const filteredFiles =
        selectedType === 'all'
            ? files
            : files.filter(f => f.type === selectedType);

    return (
        <div className="pt-16 md:pt-20 min-h-screen" data-testid="services-page">
            {/* Header */}
            <div className="bg-slate-900 text-white py-20">
                <div className="container-custom">
                    <p className="text-[#0EA5E9] font-mono text-sm uppercase tracking-wider mb-4">
                        Все необходимые материалы в одном месте
                    </p>
                    <h1 className="text-3xl md:text-5xl font-bold uppercase tracking-tight mb-4">
                        Поддержка продукции
                    </h1>
                    <p className="text-slate-400 max-w-2xl text-lg">
                        От презентаций до инструкций и паспортов — доступ к актуальным документам
                    </p>
                </div>
            </div>

            <div className="border-b border-slate-200 bg-white">
                <div className="container-custom">
                    <div className="flex items-center justify-center h-16 md:h-20 gap-6 overflow-x-auto">

                        <button
                            onClick={() => setSelectedType('all')}
                            className={`text-sm font-medium uppercase tracking-wide whitespace-nowrap transition-colors
          ${selectedType === 'all'
                                    ? 'text-[#0056D2]'
                                    : 'text-slate-700 hover:text-[#0056D2]'
                                }`}
                        >
                            {typeLabels['all']}
                        </button>

                        {availableTypes.map(type => (
                            <button
                                key={type}
                                onClick={() => setSelectedType(type)}
                                className={`text-sm font-medium uppercase tracking-wide whitespace-nowrap transition-colors
            ${selectedType === type
                                        ? 'text-[#0056D2]'
                                        : 'text-slate-700 hover:text-[#0056D2]'
                                    }`}
                            >
                                {typeLabels[type]}
                            </button>
                        ))}

                    </div>
                </div>
            </div>



            {/* Main section */}
            <section className="py-20 bg-slate-50">
                <div className="container-custom">
                    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
                        {filteredFiles.map((file, index) => {
                            const IconComponent = iconMap.hasOwnProperty(file.icon)
                                ? iconMap[file.icon as keyof typeof iconMap]
                                : Cpu;

                            return (
                                <div
                                    key={file.id}
                                    className="bg-white p-8 border-l-4 border-transparent hover:border-[#0056D2] transition-all hover:shadow-lg animate-fade-in flex flex-col"
                                    style={{ animationDelay: `${index * 0.1}s` }}
                                >   
                                    {/* Иконка */}
                                    <div className="w-14 h-14 bg-slate-100 rounded-sm flex items-center justify-center mb-6">
                                        <IconComponent className="w-6 h-6 text-slate-700" />
                                    </div>

                                    {/* Заголовок */}
                                    <h3 className="text-xl font-semibold text-slate-900 mb-3 font-sans">
                                        {file.title}
                                    </h3>

                                    {/* Формат */}
                                    <p className="text-slate-600 leading-relaxed mb-4 mt-auto">
                                        Формат: {file.format.toUpperCase()}
                                    </p>

                                    {/* Кнопка */}
                                    <a
                                        href={file.href}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        className="mt-auto text-white text-sm btn-primary"
                                    >
                                        Скачать
                                    </a>
                                </div>
                                // <div
                                //     className="bg-white p-8 border-l-4 border-transparent hover:border-[#0056D2] transition-all hover:shadow-lg animate-fade-in flex flex-col h-full justify-between"
                                // >
                                //     {/* Верхняя часть */}
                                //     <div>
                                //         {/* Иконка */}
                                //         <div className="w-14 h-14 bg-slate-100 rounded-sm flex items-center justify-center mb-6">
                                //             <IconComponent className="w-6 h-6 text-slate-700" />
                                //         </div>

                                //         {/* Заголовок */}
                                //         <h3 className="text-xl font-semibold text-slate-900 mb-3">
                                //             {file.title}
                                //         </h3>
                                //     </div>

                                //     {/* Нижняя часть */}
                                //     <div>
                                //         {/* Формат */}
                                //         <p className="text-slate-600 leading-relaxed mb-4">
                                //             Формат: {file.format.toUpperCase()}
                                //         </p>

                                //         {/* Кнопка */}
                                //         <a
                                //             href={file.href}
                                //             target="_blank"
                                //             rel="noopener noreferrer"
                                //             className="text-white text-sm btn-primary"
                                //         >
                                //             Скачать
                                //         </a>
                                //     </div>
                                // </div>
                            );
                        })}
                    </div>
                </div>
            </section>
            <ScrollToTopButton />
        </div>
    )
}